import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxImageProps {
  src: string;
  alt: string;
  className?: string;
  overlayOpacity?: number;
  overlayColor?: string;
}
export function ParallaxImage({
  src,
  alt,
  className = '',
  overlayOpacity = 0.4,
  overlayColor = 'bg-charcoal'
}: ParallaxImageProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Move the image from -15% to 15% on the Y axis as we scroll past
  const y = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);
  return <div ref={ref} className={`absolute inset-0 overflow-hidden ${className}`} data-id="element-312">
      <motion.img src={src} alt={alt} style={{
      y
    }} className="absolute inset-0 w-full h-[130%] object-cover -top-[15%]" data-id="element-313" />
      <div className={`absolute inset-0 ${overlayColor}`} style={{
      opacity: overlayOpacity
    }} data-id="element-314" />
    </div>;
}